module.exports = __webpack_public_path__ + "media/images/blue-house-996dc64f31eb503fa48309349ada78fb.png";